<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Edit Period</h4>
      </div>
      <div class="modal-body">
        <div class="form-group mb-3">
          <label>Name</label>
          <input class="form-control" [(ngModel)]="name" placeholder="Period name" type="text">
        </div>
        <div class="form-group mb-3">
          <label>Collection</label>
          <select class="form-control" [(ngModel)]="collectionId">
            <option [ngValue]="null">— None —</option>
            @for (c of collections; track c.collectionId) {
              <option [ngValue]="c.collectionId">{{ c.name }}</option>
            }
          </select>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <label>Start Date</label>
            <input class="form-control" [(ngModel)]="startDate" type="datetime-local">
          </div>
          <div class="col-sm-6">
            <label>End Date</label>
            <input class="form-control" [(ngModel)]="endDate" type="datetime-local">
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button [disabled]="isLoading" type="button" class="btn btn-secondary" (click)="modal.hide()">Cancel</button>
        <button [disabled]="isLoading" type="button" class="btn btn-primary" (click)="save()">
          @if (isLoading) { <span class="spinner-border spinner-border-sm me-1"></span> }
          Save
        </button>
      </div>
    </div>
  </div>
</div>
